import { useCommand } from '@akin-home/commands-react';
import { useCallback } from 'react';
import { DeleteCommand } from '../commands/types';

export const useDeleteCommand = (callback: () => void) => {
  useCommand<DeleteCommand>(
    'delete',
    useCallback(
      (commands) => {
        if (commands.length) {
          callback();
        }
      },
      [callback]
    )
  );

  return callback;
};
